/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VlcCardContent.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import PropTypes from "prop-types";
import { vlcComponentStyle } from "../config/vlcConfig";
import {
  Box,
  
} from "@mui/material";

function VlcCardContent({
  children,
  key,
  onClick,
  data,
  isSelected,
  cardStyle = {},
}) {
  return (
    <Box
      key={key}
      onClick={() => {
        onClick(data);
      }}
      sx={{
        ...vlcComponentStyle.cardContentBox,
        ...vlcComponentStyle.selectedCardBox(isSelected),
        ...cardStyle,
      }}
    >
      {children}
    </Box>
  );
}


VlcCardContent.propTypes = {
  children: PropTypes.node,
  key: PropTypes.any,
  onClick: PropTypes.func,
  data: PropTypes.any,
  isSelected: PropTypes.bool,
  cardStyle: PropTypes.object
};

export default VlcCardContent;
